export default "__VITE_ASSET__bcde5827__"